import {EXPRESSION_FALSE, EXPRESSION_TRUE} from "../../../constants/filter";
import {US_DATE_FORMAT} from "../../../constants/dates";
import {capitalizeFirstLetter} from "../../../utils/content";

export const prepareOptions = function (
    {
        q = '',
        current = 1,
        limit = 25,
        order_by = 'id',
        order_direction = 'desc',
        filters = [],
        extra = {}
    }
) {
    let options = {
        q: encodeURIComponent(q),
        current: current,
        limit: limit,
        order_by: order_by,
        order_direction: order_direction
    };
    let counter = {};
    filters.map(filter => {
        counter[filter.column] = counter.hasOwnProperty(filter.column) && counter[filter.column] >= 0 ? counter[filter.column] + 1 : 0;
        if (EXPRESSION_TRUE === filter.expression || EXPRESSION_FALSE === filter.expression) {
            options['filters[' + filter.column + '][' + counter[filter.column] + ']'] = filter.expression;
        } else if (filter.column && filter.value) {
            options['filters[' + filter.column + '][' + counter[filter.column] + ']'] = filter.expression + '=' + filter.value;
        }
    });
    options = Object.assign({}, options, extra);

    return options;
}
export const compileItemForExport = function (item, keys) {
    const extract = value => {
        if (value && typeof value === 'object') {
            if (value.hasOwnProperty('name')) {
                return value.name;
            } else if (value.hasOwnProperty('title')) {
                return value.title;
            } else if (value.hasOwnProperty('fname') && value.hasOwnProperty('lname')) {
                return value.fname + ' ' + value.lname;
            } else if (value.hasOwnProperty('fname')) {
                return value.fname;
            } else if (value.hasOwnProperty('lname')) {
                return value.lname;
            } else if (value.hasOwnProperty('code')) {
                return value.code;
            } else if (value.hasOwnProperty('default')) {
                return value.default;
            }

            console.error('No available attribute found. Please contact dev@mindsets.com. Found: ' + Object.keys(value).join(', '));

            return '';
        }

        throw 'Method extract() accepts Objects only. ' + typeof value + ' given';
    };

    return keys.map(key => {
        if (item.hasOwnProperty(key)) {
            const attribute = item[key];
            if (attribute && Array.isArray(attribute)) {
                return attribute.map(subitem => {
                    if (subitem && Array.isArray(subitem)) {
                        return subitem.join(', ');
                    } else if (subitem && typeof subitem === 'object') {
                        return extract(subitem);
                    } else {
                        return subitem;
                    }
                }).join(', ');
            } else if (attribute && typeof attribute === 'object') {
                return extract(attribute);
            } else if (attribute && typeof attribute === 'number' && key.indexOf('_at') > 0) {
                return new Date(attribute * 1000).toLocaleString('en-US', US_DATE_FORMAT);
            } else {
                return attribute;
            }
        }

        return '';
    });
}
export const getKeysForExport = function (items) {
    let keys = {};
    items.map(item => {
        Object.keys(item).map(key => {
            if (!keys.hasOwnProperty('key')) {
                keys[key] = capitalizeFirstLetter(key).replace(/_/g, " ");
            }
        });
    });

    return keys;
}
export const getRowNumber = function (index, current, limit) {
    return (index + 1) + (current * limit - limit);
}
